export default __webpack_public_path__ + "static/poster-dawn-6fe83b1cbe6fce7bc69c4db445bfe9d6.jpg";